import { CommonModule, NgStyle } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    SewPicture,
    SewWsBreadcrumb,
    SewWsStageHeadlineRotation,
} from '@sew/ui-components-angular/standalone';
import { CustomBreakpoint } from '../../helpers/breakpoint.helper';
import { isRetinaDisplay } from '../../helpers/retina-display.helper';
import { Author } from '../../models/author.model';
import { BlogPost } from '../../models/blog-posts.model';
import { BlogLabels } from '../../models/label.model';
import { Breadcrumbs } from '../../shared/interfaces/breadcrumb.type';
import { DateService } from '../../shared/services/date.service';
import { TagsComponent } from '../tags/tags.component';

@Component({
    selector: 'blog-hero-picture',
    templateUrl: './hero-picture.component.html',
    styleUrls: ['./hero-picture.component.scss'],
    imports: [CommonModule, NgStyle, TagsComponent, SewWsStageHeadlineRotation, SewPicture, SewWsBreadcrumb],
})
export class HeroPictureComponent {
    @Output() public authorClicked = new EventEmitter<Author>();
    @Output() public tagClicked = new EventEmitter<string>();
    @Output() public pictureClicked = new EventEmitter<BlogPost>();

    public get article(): BlogPost {
        return this._article!;
    }

    @Input() public set article(article: BlogPost) {
        this._article = article;
        this.date = this.dateService.getDate(this._article.date);
        this.initImage(this._article);
    }

    @Input() public showAuthor = false;
    @Input() public cursorPointer = false;
    @Input() public labels?: BlogLabels;
    @Input() public breakpoint: CustomBreakpoint = 0;
    @Input() public breadcrumbs: Breadcrumbs = [];

    public isRetinaDisplay = isRetinaDisplay;
    public heroPictureURL?: any;
    public url?: string;
    public date?: string;

    private _article: BlogPost | undefined;

    public constructor(private dateService: DateService) {}

    public onAuthorClicked(author: Author): void {
        this.authorClicked.emit(author);
    }

    public onTagClicked(tag: string): void {
        this.tagClicked.emit(tag);
    }

    public onPictureClicked(): void {
        this.pictureClicked.emit(this._article);
    }

    private initImage(article: BlogPost): void {
        this.heroPictureURL = article.hero_picture;
    }
}
